module.exports = __webpack_public_path__ + "img/图片19.f7b2e815.png";